import { render } from "./PayyoSettingsTab.vue?vue&type=template&id=3ce1df48"
import script from "./PayyoSettingsTab.vue?vue&type=script&lang=js"
export * from "./PayyoSettingsTab.vue?vue&type=script&lang=js"

import "./PayyoSettingsTab.vue?vue&type=style&index=0&id=3ce1df48&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__